import { GoodsUnits as Page } from './GoodsUnits.main';
import { GoodsUnitsHeader as Header } from './GoodsUnitsHeader';
export { Filters } from './Filters';
export { GoodsUnitsTable } from './GoodsUnitsTable';

export const GoodsUnits = { Header, Page };
